module.exports = __webpack_public_path__ + "img/lessonpre_push_small.6b49b051.svg";